import React from 'react';
import { Avatar } from 'antd';
import { Colors } from '@common/tokens';

export const WorksAvatar = ({
  avatarImageSrc,
  firstName,
  lastName,
  size,
}: {
  avatarImageSrc?: string;
  firstName?: string;
  lastName?: string;
  size: number;
}) => {
  let initials = '';
  if (firstName && lastName) {
    initials = [firstName, lastName]
      .map((name) => name.charAt(0))
      .join('')
      .toUpperCase();
  }

  if (avatarImageSrc) {
    return <Avatar shape="square" size={size} src={avatarImageSrc} />;
  }

  // Setting the font-size to size / 2 mimics the Ant behavior for icons.
  // For more info, please see: https://github.com/ant-design/ant-design/blob/master/components/avatar/index.tsx#L139
  return (
    <>
      <Avatar
        shape="square"
        size={size}
        className="wk-works-avatar"
        style={{
          fontSize: size / 2.25,
        }}
      >
        {initials}
      </Avatar>
      <style jsx>
        {`
          :global(.wk-works-avatar.ant-avatar) {
            background-color: ${Colors.steelLighter};
            color: ${Colors.midnightLighter};
            font-weight: 400;
            text-transform: lowercase;
          }
        `}
      </style>
    </>
  );
};
